// Categorical colors for cases in a comparison, by position (shared by 2D, 3D and the table)
export const SERIES_COLORS = ['#E8590C', '#2F6FEB', '#0E9384', '#8B5CF6'] as const;

export const getSeriesColor = (index: number): string => SERIES_COLORS[index % SERIES_COLORS.length];
